export class FabMenuModel {
	icone: string;
	descricao: string;
	rota: string[] | null;
	action: () => void | null;

	static fromRaw(raw: any): FabMenuModel {
        return Object.assign(new FabMenuModel(), raw);
    }
}
